import axios from '../axios';
import { PREFIX, VERSION } from '../enums/request';

export default class FeatureFlagResource {
  static fetchFlag() {
    return axios.get(`/${PREFIX.PARTNERS}/${VERSION.V2}/payrollloanproposals/featureflags`);
  }
}
